// src/shared/auth/AuthGuard.tsx
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../api/authConfig";
import Loading from "../../custom_components/Loading/Loading";
import CommonError from "../../custom_components/CommonError/CommonError";
import ServerEvents from "../../custom_components/ServerEvents/ServerEvents";
// import Auth2 from "../../custom_components/Auth2/Auth2";
import { getEnvironmentVariables } from "../environment";

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
    // const authRequest = loginRequest();

    const { enableADIntegration, enableServerEvents } = getEnvironmentVariables();

    // // Sin AD → usar Auth2 legacy
    // if (!enableADIntegration) {
    //     return (
    //         <>
    //             <Auth2 />
    //             {enableServerEvents && <ServerEvents />}
    //             {children}
    //         </>
    //     );
    // }

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={loginRequest}
            errorComponent={CommonError}
            // loadingComponent={Loading}
        >
            {enableServerEvents && <ServerEvents />}
            {children}
        </MsalAuthenticationTemplate>
    );
};

export default AuthGuard;
